import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, LogOut, LayoutDashboard, ShieldCheck, Search } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/NotificationBell";

export const Logo = ({ light }) => (
  <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
    <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#1E40AF] font-display text-lg font-extrabold text-white">Q</span>
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      Qui Fait Quoi
    </span>
  </Link>
);

const navCls = ({ isActive }) =>
  `text-sm font-semibold transition-colors hover:text-[#1E40AF] ${isActive ? "text-[#1E40AF]" : "text-slate-700"}`;

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = (
    <>
      <NavLink to="/recherche" className={navCls} data-testid="nav-search-link" onClick={() => setOpen(false)}>Rechercher</NavLink>
      <NavLink to="/tarifs" className={navCls} data-testid="nav-pricing-link" onClick={() => setOpen(false)}>Tarifs pros</NavLink>
      <NavLink to="/mon-espace" className={navCls} data-testid="nav-claim-link" onClick={() => setOpen(false)}>Vous êtes pro ?</NavLink>
      {user?.role === "admin" && (
        <NavLink to="/admin" className={navCls} data-testid="nav-admin-link" onClick={() => setOpen(false)}>
          <span className="inline-flex items-center gap-1"><ShieldCheck className="h-4 w-4" />Admin</span>
        </NavLink>
      )}
    </>
  );

  return (
    <header className="sticky top-0 z-[1000] border-b border-slate-200 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-7 md:flex">{links}</nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <NotificationBell />
              <Button variant="ghost" className="hidden sm:inline-flex" onClick={() => navigate("/mon-espace")} data-testid="header-dashboard-button">
                <LayoutDashboard className="mr-1 h-4 w-4" />{user.name?.split(" ")[0]}
              </Button>
              <Button variant="outline" size="icon" onClick={logout} data-testid="header-logout-button" aria-label="Déconnexion">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button onClick={() => navigate("/connexion")} className="rounded-full bg-slate-900 px-5 hover:bg-[#1E40AF] hover:text-white" data-testid="header-login-button">
              Connexion
            </Button>
          )}
          <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setOpen(!open)} data-testid="header-menu-toggle" aria-label="Menu">
            {open ? <Search className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>
      {open && <nav className="flex flex-col gap-4 border-t border-slate-200 bg-white px-6 py-4 md:hidden" data-testid="mobile-nav">{links}</nav>}
    </header>
  );
}
